import { render, staticRenderFns } from "./MeterPriceItemModal.vue?vue&type=template&id=2532765c"
import script from "./MeterPriceItemModal.vue?vue&type=script&lang=js"
export * from "./MeterPriceItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports